import { createSlice } from "@reduxjs/toolkit";

export const sessionSlice = createSlice({
  name: "sessionModal",
  initialState: {
    isOpen: false,
  },
  reducers: {
    toggleSessionModal: (state, action) => {
      state.isOpen = !action.payload;
    },
  },
});

export const { toggleSessionModal } = sessionSlice.actions;

export default sessionSlice.reducer;
